import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Avatar from "@mui/material/Avatar"
import Popover from "@mui/material/Popover"
import { MONO, CHAT_COLOR, AGENT_COLORS } from "../constants"

export function UserInfoPopover({ anchorEl, sender, profiles, users, onClose }) {
  const open = Boolean(anchorEl && sender)
  if (!sender) return null
  const isAgent = sender === "jarvis" || sender === "friday"
  const profile = profiles?.[sender]
  const online = isAgent ? true : (users?.find(u => u.username === sender)?.online ?? false)
  const onlineLabel = isAgent ? "AI Agent" : (online ? "Online" : "Offline")
  const agentColor = AGENT_COLORS[sender] ?? null
  const nameColor = profile?.name_color ?? agentColor ?? CHAT_COLOR
  const displayName = profile?.display_name ?? (isAgent ? sender.toUpperCase() : sender)
  const avatarSrc = profile?.avatar_b64 || undefined
  return (
    <Popover data-chat-overlay="true" open={open} anchorEl={anchorEl} onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      transformOrigin={{ vertical: "bottom", horizontal: "left" }}
      PaperProps={{ "data-chat-overlay": "true", sx: { backgroundColor: "var(--app-paper)", border: "1px solid " + `color-mix(in srgb, ${nameColor} 20%, transparent)`,
        borderRadius: 2, p: 2, minWidth: 180, boxShadow: "0 4px 24px rgba(var(--app-shadow-rgb),0.7)" } }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
        {avatarSrc
          ? <Avatar src={avatarSrc} sx={{ width: 40, height: 40, border: "2px solid " + `color-mix(in srgb, ${nameColor} 26.7%, transparent)` }} />
          : <Avatar sx={{ width: 40, height: 40, bgcolor: `color-mix(in srgb, ${nameColor} 13.3%, transparent)`, border: "2px solid " + `color-mix(in srgb, ${nameColor} 26.7%, transparent)`,
              color: nameColor, fontSize: 16, fontFamily: MONO }}>{displayName[0]?.toUpperCase()}</Avatar>}
        <Box>
          <Typography sx={{ fontFamily: MONO, fontSize: "0.8rem", fontWeight: 700, color: nameColor }}>{displayName}</Typography>
          <Typography sx={{ fontFamily: MONO, fontSize: "0.62rem", color: "rgba(var(--app-fg-rgb),0.4)" }}>@{sender}</Typography>
        </Box>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Box sx={{ width: 7, height: 7, borderRadius: "50%",
          backgroundColor: online ? "var(--app-success)" : "rgba(var(--app-fg-rgb),0.2)" }} />
        <Typography sx={{ fontFamily: MONO, fontSize: "0.62rem",
          color: online ? "var(--app-success)" : "rgba(var(--app-fg-rgb),0.35)" }}>
          {onlineLabel}
        </Typography>
      </Box>
    </Popover>
  )
}
